import TastypieModel from './TastypieModel';


export default class SelectableModel extends TastypieModel {
  initialize(options) {
    this.selected = false;
    super.initialize(options);
  }

  addToSelection(options) {
    this.selected = true;
    this.trigger("selected", this, options);
    this.trigger("addedToSelection", this, options);
  }

  addToNewSelection(options) {
    this.selected = true;
    this.trigger("selected", this, options);
    this.trigger("addedToNewSelection", this, options);
  }

  removeFromSelection(options) {
    this.selected = false;
    this.trigger("deselected", this, options);
    this.trigger("removedFromSelection", this, options);
  }

  deselect(options) {
    this.selected = false;
    this.trigger("deselected", this, options);
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/models/SelectableModel.js
 **/